/** Primary storage key for persisted registration JSON (pairing or tenant). Web: localStorage. */
export const PLAYER_REGISTRATION_STORAGE_KEY = 'LUCIMARK:TENANT:REGISTRATION'

/** Device-local kill-switch after OMX HAL wedge (survives WebView reload). Cleared when Admin re-enables hybrid. */
export const NATIVE_HYBRID_HAL_WEDGE_DISABLE_KEY = 'LUCIMARK:NATIVE_HYBRID_HAL_WEDGE_DISABLE'
